import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

function ShowMore(props) {
  return (
    <div
      className="col-12 d-flex flex-column align-items-center clickable"
      onClick={props.toggleIsOpen}
    >
      {props.isOpen ?
        <span className="caret-raise"/> :
        <>
          <span><Translate value="subscriptions.plans.seeMore"/></span>
          <span className="caret-drop"/>
        </>
      }
    </div>
  );
}

ShowMore.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleIsOpen: PropTypes.func.isRequired
};

export default ShowMore;
